/**
 * Words for Reports → Sickness and Reports → Getting a break (Reports step 4, 12/10/2026).
 * Pure, so lib/sicknessWords.checks.mjs can pin them.
 */
import { formatDateGB } from './dates.js';

const fmt = (n) => Number(n || 0).toLocaleString('en-GB', { maximumFractionDigits: 2 });

/** "1 day", "2 days", "0.5 days" */
export function daysWord(n) {
  return `${fmt(n)} ${Number(n) === 1 ? 'day' : 'days'}`;
}

/** "Monday 06/10/2026", or "Friday 29/05/2026 – Monday 01/06/2026" for more than a day. */
export function absenceWhen(a) {
  if (!a) return '';
  const from = `${a.from_day} ${formatDateGB(a.from)}`;
  if (a.from === a.to) return from;
  return `${from} – ${a.to_day} ${formatDateGB(a.to)}`;
}

/** "5 absences × 5 × 7 days = 175" — the Bradford sum written out. */
export function bradfordSum(row) {
  if (!row) return '';
  const n = row.absences;
  return `${n} ${n === 1 ? 'absence' : 'absences'} × ${n} × ${daysWord(row.days)} = ${row.bradford}`;
}

/** The "Last break" cell for one person on Getting a break. */
export function lastBreakText(row) {
  if (!row) return { main: '', sub: '' };
  if (row.on_break) return { main: 'On a break now', sub: '' };
  if (row.none_on_record) {
    const from = row.counted_from ? formatDateGB(row.counted_from) : '';
    const part = partDayNote(row.part_day_since);
    const base = row.joined_recently ? (from ? `joined ${from}` : '') : (from ? `added ${from}` : '');
    return {
      main: row.joined_recently ? 'None since joining' : 'None on record',
      sub: [base, part].filter(Boolean).join(' · '),
    };
  }
  return { main: formatDateGB(row.last_break), sub: partDayNote(row.part_day_since) };
}

/** "a half day on 20/07 isn't counted" — so a part day after the last break doesn't make the
 *  row look wrong (Rob, 12/10/2026: Alan Turing). */
export function partDayNote(part) {
  if (!part) return '';
  const what = Math.abs(Number(part.days) - 0.5) < 0.01 ? 'a half day' : 'a part day';
  return `${what} on ${formatDateGB(part.date).slice(0, 5)} isn't counted`;
}

/** The chips for one person on Getting a break. */
export function breakChips(row, threshold) {
  if (!row) return [];
  const out = [];
  if (row.over) out.push({ tone: 'danger', text: `Over ${threshold} days` });
  else if (row.nearly) out.push({ tone: 'pending', text: `Nearly ${threshold}` });
  if (row.next_booked) out.push({ tone: 'success', text: row.next_waiting ? 'Booked, waiting for approval' : 'Booked' });
  return out;
}
